import { FC } from 'react';
import { Typography } from '@mui/material';

import styles from './ToggleRadioButton.module.scss';

const ToggleRadioButton: FC<{ value: string; label: string; selected: boolean }> = ({ value, label, selected }) => (
  <div className={`${styles.toggleButton} ${selected ? styles.selected : ""}`}>
    {selected ? (
      <Typography variant='h10Semibold'>{label}</Typography>
    ) : (
      <Typography variant='h10'>{label}</Typography>
    )}
  </div>
);

export default ToggleRadioButton;
